import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { BBInvitationView, BBInvitationViewDefaultValues } from 'src/app/components/invitations/bb-invitations/bb-invitation';
import { AuthService } from 'src/app/services/auth.service';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';

@Component({
    selector: 'app-view-bb-invitations',
    templateUrl: './view-bb-invitations.component.html',
    styleUrls: ['./view-bb-invitations.component.scss'],
    standalone: false
})
export class ViewBbInvitationsComponent {


  bbInvitation:BBInvitationView=BBInvitationViewDefaultValues();
  id: string = '';
  auditLogs :any[]=[]
  pageName = CheckPageAccess.BBINVITATIONS
  showEditButton=true;
  constructor(private _bbinviteservice:BbInvitationService,private route:ActivatedRoute,private router:Router,private authservice:AuthService) { }
  
  showResendForm=false;
  newExpiryDate='';
  minExpiryDate='';
  resendMessage='';
  resendFailed=false;
  isResending=false;

  ngOnInit(): void {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate()+1);
    this.minExpiryDate = tomorrow.toISOString().split('T')[0];

    this.route.params.subscribe((params)=>{
      this.id=params['id'];
      this.loadDetails();
    })

    this.showEditButton = this.authservice.getAccessControl().editBBInvitation

  }

  loadDetails() {
    this._bbinviteservice.getBBInvitationDetailsForView(this.id).subscribe({
      next:(response)=>
        {
          this.bbInvitation=response;
        }
    })

    this._bbinviteservice.getBBInvitationAuditLogs(this.id).subscribe({
      next:(response)=>
      {
        this.auditLogs=response;
      }
    })
  }

  get canResend(): boolean {
    return this.showEditButton && this.bbInvitation.statusDescription === 'Inactive-Expired';
  }

  openResend() {
    this.newExpiryDate = '';
    this.resendMessage = '';
    this.resendFailed = false;
    this.showResendForm = true;
  }

  closeResend() {
    if (!this.isResending) {
      this.showResendForm = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.closeResend();
  }

  resend() {
    if (!this.newExpiryDate) {
      this.resendFailed = true;
      this.resendMessage = 'Please select a new expiry date.';
      return;
    }
    this.isResending = true;
    this._bbinviteservice.resendBBInvitation(this.id, this.newExpiryDate).subscribe({
      next:(response)=>
      {
        this.isResending = false;
        this.resendFailed = !response.status;
        this.resendMessage = response.message;
        if (response.status) {
          this.showResendForm = false;
          this.newExpiryDate = '';
          this.loadDetails();
        }
      },
      error:()=>
      {
        this.isResending = false;
        this.resendFailed = true;
        this.resendMessage = 'Unable to resend the invitation. Please try again.';
      }
    })
  }

  navigate() {
    this.router.navigateByUrl('/edit-bb-invitation/'+this.id);
    }
}
